import { useLayoutEffect } from 'react';
import { useMap } from 'react-leaflet';

export const HEAT_PANE = 'heatPane';
export const BOUNDARIES_PANE = 'boundariesPane';
export const ALERTS_PANE = 'alertsPane';

/**
 * Ordena as camadas dos mapas do InteractiveMap (pedido da Bruna em
 * 28/08/2026): variavel exibida -> limites estaduais -> alerta de estresse ->
 * pin da localidade.
 *
 * Antes as tres primeiras caiam todas no `overlayPane`, entao quem aparecia por
 * cima era a ultima a entrar no DOM: as divisas chegam por `fetch` e o canvas da
 * mancha volta pro fim da fila toda vez que "Exibir variavel" religa. Panes
 * proprios travam a ordem independente de quem monta primeiro.
 *
 * A escada precisa listar tambem os panes nativos porque o
 * `.map-container .leaflet-pane { z-index: 0 }` do index.scss tem mais
 * especificidade que os seletores do leaflet.css e achata todos eles em zero.
 * Estilo inline vence essa regra; sem repetir os nativos aqui, os panes novos
 * subiriam por cima do `markerPane` e esconderiam os pins.
 */
const PANE_Z_INDEX: [string, number][] = [
  ['tilePane', 200],
  ['overlayPane', 400],
  [HEAT_PANE, 410],
  [BOUNDARIES_PANE, 420],
  [ALERTS_PANE, 430],
  ['shadowPane', 500],
  ['markerPane', 600],
  ['tooltipPane', 650],
  ['popupPane', 700],
];

export default function MapPanes() {
  const map = useMap();

  // useLayoutEffect de proposito: os efeitos do react-leaflet sao passivos, e
  // todo passivo roda depois de todo layout. Assim os panes existem antes de
  // qualquer camada montar, sem depender da ordem dos filhos do mapa.
  useLayoutEffect(() => {
    if (!map) return;

    PANE_Z_INDEX.forEach(([name, zIndex]) => {
      // `createPane` nao checa se ja existe, ao contrario do que a doc dele diz:
      // chamar duas vezes cria uma div orfa e abandona as camadas na antiga.
      const pane = map.getPane(name) ?? map.createPane(name);
      pane.style.zIndex = String(zIndex);
    });
  }, [map]);

  return null;
}
